module.exports = __webpack_public_path__ + "static/img/moaInstallForMac_pic10.5a27458.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForMac/moaInstallForMac_pic10.png
// module id = 528
// module chunks = 1